import * as styles from './DropdownList.css';
import { memo, PropsWithChildren } from 'react';
import { DropdownList as Interface } from './types';
import Disclosure from '../Disclosure';
import CheckBox from '../CheckBox/CheckBox';
import { NavChevronSmallDownIcon } from '@/assets/icons';
import Button from '../Button/Button';

const DropdownList = (props: PropsWithChildren<Interface.Props>) => {
  const { children } = props;

  return (
    <Disclosure>
      <Disclosure.Button className={styles.button}>
        {({ value }) => (
          <>
            <div>
              {props.type === 'with-check' && (
                <Check
                  value={props.checked}
                  onChangeValue={props.onChangeChecked}
                />
              )}
              <h3 className={styles.title}>{props.title}</h3>
            </div>
            <Instruction value={value} />
          </>
        )}
      </Disclosure.Button>
      <Disclosure.Panel className={styles.panel}>{children}</Disclosure.Panel>
    </Disclosure>
  );
};

const Instruction = ({ value }: Interface.InstructionProps) => {
  return (
    <NavChevronSmallDownIcon
      className={styles.instruction({ expanded: value })}
    />
  );
};

const Check = memo(({ value, onChangeValue }: Interface.CheckProps) => {
  const onChange = () => {
    onChangeValue(!value);
  };

  return <CheckBox value={value} onChange={onChange} />;
});
Check.displayName = 'DropDownButtonCheck';

const Text = ({ value }: Interface.TextProps) => {
  return <p className={styles.text}>{value}</p>;
};

const Iframe = ({ src }: Interface.IframeProps) => {
  return <iframe src={src}></iframe>;
};

const Link = ({ title, url }: Interface.LinkProps) => {
  return (
    <Button
      as="a"
      style={{ alignItems: 'self-start' }}
      type="textNonePadding"
      size="medium"
      href={url}
      category="primary"
      underline
    >
      {title}
    </Button>
  );
};

const Image = ({ alt = '', src }: Interface.ImageProps) => {
  return <img src={src} alt={alt} className={styles.image} />;
};

DropdownList.Text = Text;
DropdownList.Link = Link;
DropdownList.Image = Image;
DropdownList.Iframe = Iframe;

export default DropdownList;
